module.exports = __webpack_public_path__ + "static/media/anquanxiaozu2.6a57716b.png";